{
 "source": "InterVA-5 causetext",
 "causes": [
  {
   "code": "a_nrp",
   "name": "Not pregnant or recently delivered",
   "kind": "pregnancy",
   "whoVa": null
  },
  {
   "code": "a_pend_6w",
   "name": "Pregnancy ended within 6 weeks of death",
   "kind": "pregnancy",
   "whoVa": null
  },
  {
   "code": "a_preg",
   "name": "Pregnant at death",
   "kind": "pregnancy",
   "whoVa": null
  },
  {
   "code": "b_0101",
   "name": "Sepsis (non-obstetric)",
   "kind": "cause",
   "whoVa": "VAs-01.01"
  },
  {
   "code": "b_0102",
   "name": "Acute resp infect incl pneumonia",
   "kind": "cause",
   "whoVa": "VAs-01.02"
  },
  {
   "code": "b_0103",
   "name": "HIV/AIDS related death",
   "kind": "cause",
   "whoVa": "VAs-01.03"
  },
  {
   "code": "b_0104",
   "name": "Diarrhoeal diseases",
   "kind": "cause",
   "whoVa": "VAs-01.04"
  },
  {
   "code": "b_0105",
   "name": "Malaria",
   "kind": "cause",
   "whoVa": "VAs-01.05"
  },
  {
   "code": "b_0106",
   "name": "Measles",
   "kind": "cause",
   "whoVa": "VAs-01.06"
  },
  {
   "code": "b_0107",
   "name": "Meningitis and encephalitis",
   "kind": "cause",
   "whoVa": "VAs-01.07"
  },
  {
   "code": "b_0108",
   "name": "Tetanus",
   "kind": "cause",
   "whoVa": "VAs-01.08"
  },
  {
   "code": "b_0109",
   "name": "Pulmonary tuberculosis",
   "kind": "cause",
   "whoVa": "VAs-01.09"
  },
  {
   "code": "b_0110",
   "name": "Pertussis",
   "kind": "cause",
   "whoVa": "VAs-01.10"
  },
  {
   "code": "b_0111",
   "name": "Haemorrhagic fever (non-dengue)",
   "kind": "cause",
   "whoVa": "VAs-01.11"
  },
  {
   "code": "b_0112",
   "name": "Dengue fever",
   "kind": "cause",
   "whoVa": "VAs-01.12"
  },
  {
   "code": "b_0199",
   "name": "Other and unspecified infect dis",
   "kind": "cause",
   "whoVa": "VAs-01.99"
  },
  {
   "code": "b_0201",
   "name": "Oral neoplasms",
   "kind": "cause",
   "whoVa": "VAs-02.01"
  },
  {
   "code": "b_0202",
   "name": "Digestive neoplasms",
   "kind": "cause",
   "whoVa": "VAs-02.02"
  },
  {
   "code": "b_0203",
   "name": "Respiratory neoplasms",
   "kind": "cause",
   "whoVa": "VAs-02.03"
  },
  {
   "code": "b_0204",
   "name": "Breast neoplasms",
   "kind": "cause",
   "whoVa": "VAs-02.04"
  },
  {
   "code": "b_0205",
   "name": "Reproductive neoplasms MF",
   "kind": "cause",
   "whoVa": "VAs-02.05"
  },
  {
   "code": "b_0299",
   "name": "Other and unspecified neoplasms",
   "kind": "cause",
   "whoVa": "VAs-02.99"
  },
  {
   "code": "b_0301",
   "name": "Severe anaemia",
   "kind": "cause",
   "whoVa": "VAs-03.01"
  },
  {
   "code": "b_0302",
   "name": "Severe malnutrition",
   "kind": "cause",
   "whoVa": "VAs-03.02"
  },
  {
   "code": "b_0303",
   "name": "Diabetes mellitus",
   "kind": "cause",
   "whoVa": "VAs-03.03"
  },
  {
   "code": "b_0401",
   "name": "Acute cardiac disease",
   "kind": "cause",
   "whoVa": "VAs-04.01"
  },
  {
   "code": "b_0402",
   "name": "Stroke",
   "kind": "cause",
   "whoVa": "VAs-04.02"
  },
  {
   "code": "b_0403",
   "name": "Sickle cell with crisis",
   "kind": "cause",
   "whoVa": "VAs-04.03"
  },
  {
   "code": "b_0499",
   "name": "Other and unspecified cardiac dis",
   "kind": "cause",
   "whoVa": "VAs-04.99"
  },
  {
   "code": "b_0501",
   "name": "Chronic obstructive pulmonary dis",
   "kind": "cause",
   "whoVa": "VAs-05.01"
  },
  {
   "code": "b_0502",
   "name": "Asthma",
   "kind": "cause",
   "whoVa": "VAs-05.02"
  },
  {
   "code": "b_0601",
   "name": "Acute abdomen",
   "kind": "cause",
   "whoVa": "VAs-06.01"
  },
  {
   "code": "b_0602",
   "name": "Liver cirrhosis",
   "kind": "cause",
   "whoVa": "VAs-06.02"
  },
  {
   "code": "b_0701",
   "name": "Renal failure",
   "kind": "cause",
   "whoVa": "VAs-07.01"
  },
  {
   "code": "b_0801",
   "name": "Epilepsy",
   "kind": "cause",
   "whoVa": "VAs-08.01"
  },
  {
   "code": "b_0901",
   "name": "Ectopic pregnancy",
   "kind": "cause",
   "whoVa": "VAs-09.01"
  },
  {
   "code": "b_0902",
   "name": "Abortion-related death",
   "kind": "cause",
   "whoVa": "VAs-09.02"
  },
  {
   "code": "b_0903",
   "name": "Pregnancy-induced hypertension",
   "kind": "cause",
   "whoVa": "VAs-09.03"
  },
  {
   "code": "b_0904",
   "name": "Obstetric haemorrhage",
   "kind": "cause",
   "whoVa": "VAs-09.04"
  },
  {
   "code": "b_0905",
   "name": "Obstructed labour",
   "kind": "cause",
   "whoVa": "VAs-09.05"
  },
  {
   "code": "b_0906",
   "name": "Pregnancy-related sepsis",
   "kind": "cause",
   "whoVa": "VAs-09.06"
  },
  {
   "code": "b_0907",
   "name": "Anaemia of pregnancy",
   "kind": "cause",
   "whoVa": "VAs-09.07"
  },
  {
   "code": "b_0908",
   "name": "Ruptured uterus",
   "kind": "cause",
   "whoVa": "VAs-09.08"
  },
  {
   "code": "b_0999",
   "name": "Other and unspecified maternal CoD",
   "kind": "cause",
   "whoVa": "VAs-09.99"
  },
  {
   "code": "b_1001",
   "name": "Prematurity",
   "kind": "cause",
   "whoVa": "VAs-10.01"
  },
  {
   "code": "b_1002",
   "name": "Birth asphyxia",
   "kind": "cause",
   "whoVa": "VAs-10.02"
  },
  {
   "code": "b_1003",
   "name": "Neonatal pneumonia",
   "kind": "cause",
   "whoVa": "VAs-10.03"
  },
  {
   "code": "b_1004",
   "name": "Neonatal sepsis",
   "kind": "cause",
   "whoVa": "VAs-10.04"
  },
  {
   "code": "b_1006",
   "name": "Congenital malformation",
   "kind": "cause",
   "whoVa": "VAs-10.06"
  },
  {
   "code": "b_1099",
   "name": "Other and unspecified neonatal CoD",
   "kind": "cause",
   "whoVa": "VAs-10.99"
  },
  {
   "code": "b_1101",
   "name": "Fresh stillbirth",
   "kind": "cause",
   "whoVa": "VAs-11.01"
  },
  {
   "code": "b_1102",
   "name": "Macerated stillbirth",
   "kind": "cause",
   "whoVa": "VAs-11.02"
  },
  {
   "code": "b_1201",
   "name": "Road traffic accident",
   "kind": "cause",
   "whoVa": "VAs-12.01"
  },
  {
   "code": "b_1202",
   "name": "Other transport accident",
   "kind": "cause",
   "whoVa": "VAs-12.02"
  },
  {
   "code": "b_1203",
   "name": "Accid fall",
   "kind": "cause",
   "whoVa": "VAs-12.03"
  },
  {
   "code": "b_1204",
   "name": "Accid drowning and submersion",
   "kind": "cause",
   "whoVa": "VAs-12.04"
  },
  {
   "code": "b_1205",
   "name": "Accid expos to smoke fire & flame",
   "kind": "cause",
   "whoVa": "VAs-12.05"
  },
  {
   "code": "b_1206",
   "name": "Contact with venomous plant/animal",
   "kind": "cause",
   "whoVa": "VAs-12.06"
  },
  {
   "code": "b_1207",
   "name": "Accid poisoning & noxious subs",
   "kind": "cause",
   "whoVa": "VAs-12.07"
  },
  {
   "code": "b_1208",
   "name": "Intentional self-harm",
   "kind": "cause",
   "whoVa": "VAs-12.08"
  },
  {
   "code": "b_1209",
   "name": "Assault",
   "kind": "cause",
   "whoVa": "VAs-12.09"
  },
  {
   "code": "b_1210",
   "name": "Exposure to force of nature",
   "kind": "cause",
   "whoVa": "VAs-12.10"
  },
  {
   "code": "b_1299",
   "name": "Other and unspecified external CoD",
   "kind": "cause",
   "whoVa": "VAs-12.99"
  },
  {
   "code": "b_9800",
   "name": "Other and unspecified NCD",
   "kind": "cause",
   "whoVa": "VAs-98.00"
  },
  {
   "code": "c_cult",
   "name": "Culture",
   "kind": "circumstance",
   "whoVa": null
  },
  {
   "code": "c_emer",
   "name": "Emergency",
   "kind": "circumstance",
   "whoVa": null
  },
  {
   "code": "c_hsys",
   "name": "Health systems",
   "kind": "circumstance",
   "whoVa": null
  },
  {
   "code": "c_inev",
   "name": "Inevitable",
   "kind": "circumstance",
   "whoVa": null
  },
  {
   "code": "c_know",
   "name": "Knowledge",
   "kind": "circumstance",
   "whoVa": null
  },
  {
   "code": "c_resr",
   "name": "Resources",
   "kind": "circumstance",
   "whoVa": null
  }
 ]
}